import { observable, computed, action, intercept, toJS } from "mobx"; //{ set, toJS }
import { Match } from "./models/Match";
import { comm } from "../comm";
import { integration } from "../integration";
import {orderBy, sortBy, sum} from 'lodash';

class MainStore {
	gameVersion = '199_7';

	constructor(){
		intercept(this, "state", (change) => {
			// console.log(change);
			var states = ['','lobby', 'waitForMatch', 'login', 'resume', 'tutorial', 'bet', 'tutorial-rules', 'play'];
			if(states.indexOf(change.newValue) < 0){
				throw new Error(`${change.newValue}, is not a valid state. => ${states}`);
			}
			return change;
		});
		setInterval(this.pollNotifications, 10000);
		window.usedImages = this.usedImages;
	}

	@observable topBar = {
		to: "",
		hide: false
	}

	// @computed get topBar(){
	// 	return this._topBar;
	// }

	// set topBar(val){

	// }

	isHardRock = false;

	usedImages = [

	];

	tresCommas(value) {
		return ' ';// value.toLocaleString();
	}

	pollNotifications = () => {
		if(process.env.NODE_ENV === 'development' || this.lastNotificationUpdate < Date.now() - 5000){
			this.awaitingNotifications = true;
		}
		if(this.awaitingNotifications === true && this.processNotifications === true && this.user && this.user.id > 0){
			this.awaitingNotifications = false;
			integration.processNotifications();
		}
	}

	@observable localStorageSynced = false || window.location.hostname === "localhost" || window.location.hash === '#dev';

	@observable purchaseComplete = false;
	@observable purchasedHearts = 0;

	@observable focus = true;

	@observable preventReturnToSplash = false;

	@observable imageData = {};

	@observable debugArray = [];

	@computed get shouldTutorialAwardXp(){
		return this.user.xpData.currentXp === 0;
	}

	@observable _settings = JSON.parse(localStorage.getItem('settings')) || {
		sound: true,
		music: true,
		language: 'en',
		notifications: true,
		vibration: true
	}

	@observable showBottomNav = false;

	@computed get settings(){
		return this._settings;
	}

	@computed get getLanguage(){
		// return 'es';
		return this._settings.language;
	}

	@action changeSetting(key, value){
		this._settings[key] = value ? value : !this._settings[key];
		setPersistentStorage('settings', JSON.stringify(toJS(this._settings)));
	}

	@observable products = [];
	@observable showProductStore = false;
	@observable productStoreReady = false;

	@observable showAchievements = false;
	@observable showAchRewardBanner = []; //['bronze',150];
	@observable showLevelUpReward = [];
	@observable showTimedHeartAward = 0;
	@observable showCountdownModal = false;

	@observable phaserInstanceIndex = 1;
	@observable phaserGameCreated = false;

	@observable aspectRatio = 0;

	@observable showFirstGameMessages = localStorage.getItem('hasSeenFirstGameMessage') !== "true" || false;
	@observable showAvaNewGameMessage = false;

	aspectIs(name){
		return this.aspectName === name;
	}

	forceGetNotifications(){
		return integration.processNotifications();
	}

	@observable debug = '';

	@observable activeDebug = "inactive";

	@computed get aspectName(){
		//anything taller than an iPhone 6 1334/750
		if(this.aspectRatio < 0.5621){
			return 'Tall'; //Like the iPhone X
		}
		//anything taller than an iPad Pro 11 inch
		if(this.aspectRatio < 0.6984){
			return 'Standard'; // Like the iPhone 4 - 8
		}
		if(this.aspectRatio < 0.7){
			return 'TabletPro'; // Like the iPad Pro 11 inch
		}
		if(this.aspectRatio < 0.752){
			return 'Tablet';
		}
		return 'Landscape';
	}

	@observable preloading = true;

	@observable phaserLoadPercentage = 0;

	@observable reactLoadPercentage = 0;

	@computed get totalLoadPercentage(){
		var percentagesToCombine = [
			this.phaserLoadPercentage,
			this.reactLoadPercentage
		];
		var total = sum(percentagesToCombine) / percentagesToCombine.length;
		if(total >= 100){
			integration.postAnalyticsEvent('preload_end', 'user_experience', Date.now().toString());
			setTimeout(() => this.preloading = false, 1000);
		}
		return total;
	}

	@observable _fcmId = null;
	@computed get fcmId(){
		return this._fcmId;
	}
	set fcmId(value){
		debugger;
		var updated = this._fcmId !== value;
		//if we get a 2nd fcmId we should update the server again.
		if(store.user && store.user.guest.isLoggedIn && store.settings.notifications && updated && value !== null){
			setTimeout(() => {
				comm.RegisterFCM(value).then(() => {
					this._fcmId = value;
				});
			}, 1000);
		} else {
			this._fcmId = value;
		}
	}

	@observable loginComplete = false;

	//native notifications

	@observable notifications = [];
	@observable seenNotifications = JSON.parse(localStorage.getItem('seenNotifications')) || [];
	@observable processNotifications = true;
	@observable awaitingNotifications = false;
	@observable lastNotificationUpdate = 0;
	@observable lobbyUpdateTime = 0;
	@observable confirmedRewards = [];

	@observable rewards = [];
	@observable nudges =[];

	@computed get rewardsByAch(){
		var sorted = {};
		this.rewards.forEach(r => {
			if(r.Data.Achieve){
				if(sorted[r.Data.Achieve]){
					sorted[r.Data.Achieve].push(r)
				} else {
					sorted[r.Data.Achieve] = [r];
				}
			}
		})
		return sorted;
	}

	@computed get unseenNotifications(){
		return this.notifications.concat(this.rewards)
			.filter(n => this.seenNotifications.indexOf(n.ConfirmationKey) === -1);
	}

	@action.bound setSeenNotification(keys){
		if(typeof keys !== 'object'){
			keys = [keys]
		}
		keys.forEach(confirmKey => {
			if(this.seenNotifications.indexOf(confirmKey) === -1){
				this.seenNotifications.push(confirmKey);
			}
		});
		setPersistentStorage('seenNotifications', JSON.stringify(this.seenNotifications));
	}

	@observable loginMethod = '';

	@observable currentTosId = -1;

	@observable acceptedTosId = 0;

	@computed get tosIsAccepted() {
		return true;
	}

	@action getTosVersion(){
		this.currentTosId = 0;
	}

	@observable facebookFriends = [];//[{name: "Tom Donelan", id: "2723252121043271"},{name: "Mo Bellini", id: "3003890252994623"}, {name: "Brittainy Neifer", id: "1043749029322115"}];;
	@observable facebookFriendDetails = [];
	@observable facebookFriendsListLoaded = false;

	@observable recentOpponents = [];

	@action.bound getFacebookFriends(){
		this.user.facebook.getFreshToken()
		.then(accessToken => {
			if(accessToken){
				FB.api('/me/friends?limit=100', 'GET', {
					"access_token": accessToken
				}, (response) => {
					if(response.error && response.error.code){
						console.error(response.error.message);
					}
					if(response.paging && response.paging.cursors.after){
						FB.api('/me/friends', 'GET', {
							"after": response.paging.cursors.after,
							"access_token": accessToken
						}, (pageData) => {
							console.log(pageData)
						});
					}
					var fbFriends = response.data || [];
					if(process.env.NODE_ENV === 'development'){
						//console.log("/me/friends", response);
					}

					store.facebookFriends = fbFriends;

					comm.GetFriendDetails(fbFriends.map(f => f.id))
					.then((response) => {
						if(process.env.NODE_ENV === 'development'){
							//console.log("GetFriendDetails", response);
						}
						var sortedFriends = sortBy(response.Payload.Friends, f => f.Name);
						sortedFriends.forEach(f => {
							var summary = response.Payload.OpponentSummaries.find(s => s.UserId === f.UserId);
							f.summary = summary;
							f.summary.totalGamesAgainst = summary.LossesAgainst + summary.WinsAgainst;
						})
						store.facebookFriendDetails.replace(sortedFriends);
						store.facebookFriendDetails.forEach(element => {
							let obj = store.facebookFriends.find(x => x.id === element.PlatformUid);
							if(obj){
								element.name = obj.name;
							}
						});
						store.addRecentOpponents(response);
						store.facebookFriendsListLoaded = true;
					});
				});
			} else {
				store.facebookFriends = [];
				comm.GetFriendDetails()
				.then((response) => {
					if(process.env.NODE_ENV === 'development'){
						//console.log("GET FRIEND DETAILS", response);
					}
					store.addRecentOpponents(response);
					store.facebookFriendsListLoaded = true;
				});
			}
		})
	}

	@observable firstTimeRules = true;

	@observable botListData = [];

	getRandomBotId(){
		return this.botListData[Math.floor(Math.random() * this.botListData.length)].UserId;
	}

	@action.bound getBotListData(){
		return comm.GetBotList().then((result) => {
			store.botListData = result.Payload.Bots;
		});
	}

	@action updateMatchIfStale(id, force){
		comm.GetMatch(id)
		.then(response => {
			this.matchDetails[id] = response.Payload.Match;
		})
	}

	@observable showProfile = false;

	@observable matchData = {
		pr: [],
		is: [],
		pe: [],
		pl: [],
		wa: [],
		cl: [],
		co: []
	};

	lastButtonTime = 0;

	@computed get hasYourTurnMatches(){
		return this.matchData.pe.length > 0 ||	this.yourTurnSortedMatches.length > 0;
	}

	@computed get hasOpponentTurnMatches(){
		return this.matchData.wa.length > 0 || this.matchData.is.length > 0;
	}

	@observable matchDetails = {};

	@observable completedMatchData = [];

	@observable opponentSummaries = [];
	@observable opponentSummaryIds = [];

	latestLobbyPromise = null;

	@action.bound getLobbyData(){
		this.latestLobbyPromise = comm.GetLobby()
		.then((result) => {
			var Payload = result.Payload;

			this.opponentSummaries = Payload.OpponentSummaries;
			this.opponentSummaryIds = Payload.OpponentSummaries.map(s => s.UserId);

			var matches = {
				pr: [],
				is: [],
				pe: [],
				pl: [],
				wa: [],
				cl: [],
				co: []
			};
			Payload.MatchSummaries.forEach((m) => {
				matches[m.UserState].push(m);
			});
			// console.log(matches);
			this.matchData.pr.replace(orderBy(matches.pr, ['MatchCreatedTime'], ['asc']));
			this.matchData.is.replace(orderBy(matches.is, ['MatchCreatedTime'], ['desc']));
			this.matchData.pe.replace(orderBy(matches.pe, ['MatchCreatedTime'], ['asc']));
			this.matchData.pl.replace(orderBy(matches.pl, ['MatchCreatedTime'], ['asc']));
			this.matchData.wa.replace(orderBy(matches.wa, ['MatchCreatedTime'], ['desc']));
			this.matchData.cl.replace(orderBy(matches.cl, ['MatchCreatedTime'], ['asc']));
			this.matchData.co.replace(orderBy(matches.co, ['MatchCreatedTime'], ['desc']));

			var sortedComplete = orderBy(Payload.CompletedSummaries, ['OpponentActiveTime'],['desc']);
			// console.log('sortedComplete', sortedComplete, Payload.CompletedSummaries);

			this.completedMatchData.replace(sortedComplete);


			//If no completed matches against a human then show first game message
			this.showFirstGameMessages = localStorage.getItem('hasSeenFirstGameMessage') === "true" ? false : this.completedMatchData.filter(m => !m.OpponentIsBot).length === 0;
			//If no matches played or started then show Ava in lobby.
			this.showAvaNewGameMessage = Payload.MatchSummaries.length === 0 && Payload.CompletedSummaries.length === 0;
		});
		return this.latestLobbyPromise;
	}

	@computed get yourTurnSortedMatches(){
		var combined = [].concat(this.matchData.pr,this.matchData.pl,this.matchData.cl);
		return orderBy(combined,['OpponentActiveTime'],['desc']);
	}

	@action userShownFirstGameMessage(){
		setPersistentStorage('hasSeenFirstGameMessage', "true");
		this.showFirstGameMessages = false;
	}

	getOpponentSummaryById = (id) => {
		return this.opponentSummaries[this.opponentSummaryIds.indexOf(id)];
	}

	addRecentOpponents(response) {
		var unsortedOpponents = [];
		if(response.Payload.RecentOpponents){
			response.Payload.RecentOpponents.forEach(element => {
				let obj1 = store.facebookFriendDetails.find(x => x.UserId === element.UserId);
				let obj2 = unsortedOpponents.find(x => x.UserId === element.UserId);
				if(!obj1 && !obj2) {
					let newElement = element;
					newElement.name = newElement.Name || newElement.DisplayName || newElement.Username;
					if(!newElement.name || newElement.name === ''){
						newElement.name = newElement.PlatformUid;// 'user_'+newElement.UserId;
					}
					newElement.Name = newElement.name;
					unsortedOpponents.push(newElement);
				}
			});
			unsortedOpponents.forEach(f => {
				var summary = response.Payload.OpponentSummaries.find(s => s.UserId === f.UserId);
				f.summary = summary;
				f.summary.totalGamesAgainst = summary.LossesAgainst + summary.WinsAgainst;
			})
			store.recentOpponents.replace(sortBy(unsortedOpponents, o => o.summary.totalGamesAgainst).slice(0,25));
		}
	}


	@action.bound createMatch(oppId, rematchId){
		return comm.CreateMatch(oppId, rematchId)
		.then(data => data.Payload);
	}

	@action.bound createRandomMatch(){
		this.waitingForMatch = true;
		return comm.CreateRandomMatch()
		.then(data => {
			const p = data.Payload;
			if(p.Match.Id){
				return data.Payload;
			}
			return false;
		});
	}

	@observable matchSummaries = [];
	@observable opponentTurnMatches = [];
	@observable completedSummaries = [];

	@observable waitingForMatch = false;

	@observable waitForOpponent = false;

	@observable unsupportedDevice = false;

	get integration(){
		return process.env.INTEGRATION;
	}

	@computed get canUseExtraRoll(){
		return this.activeMatch.canApplyFreeroll && this.user.hearts > 0 && !this.activeMatch.currentHand.best && !this.activeMatch.currentHand.complete;
	}
	@computed get isEligibleForRewardRoll(){
		return this.activeMatch.canApplyFreeroll && this.user.hearts <= 0 && !this.activeMatch.currentHand.best && !this.activeMatch.currentHand.complete;
	}
	@computed get canUseHandReset(){
		return this.activeMatch.canApplyHandReset && this.user.hearts >= 5;
	}

	@computed get playOrSkip(){
		return this.activeMatch.currentHand.isWinningHand || !this.canUseExtraRoll;
	}

	@observable skin = '';

	@observable phaserReady = false;

	@observable countBets = 0;

	@observable modal = '';

	autoOpenModalAfterAd = true;

	@observable suppressAchToastsUntil = 0;

	@observable matchIdToResign = 0;

	@observable showTutorialCompleteBubble = false;

	@observable bubbleNum = 0;
	@observable rewardAdModalHearts = 0;
	enableAds = true;
	turnsThisSession = 0;
	turnsSinceLastAdView = 0;
	videoAdIsLoaded = false;
	enableRewardAds = true;
	wrapperCommandProcessing = false;
	wrapperVersion = 'web';
	wrapperLocalPath = 'web';
	firstLaunchUtcSecs = '';
	hasPurchasedIAP = '';

	// @observable tutorialSkipPressed = false;
	@observable devicePlatform = localStorage.getItem('platform') || 'web'; // 'ios' | 'android'
	@computed get isIOS(){
		return this.devicePlatform === 'ios';
	}
	@computed get isAndroid(){
		return this.devicePlatform === 'android';
	}
	rewardAdIsLoaded = false;

	@observable exitRequestReceived = false;

	@observable state = 'login';

	@observable user = null;

	@observable activeMatch = null;

	@observable resuming = true;
	@computed get gameFromResume(){
		if(store.activeMatch && store.activeMatch.fromResume){
			return true;
		}
		return false;
	};

	@observable betProcessing = false;

	@observable tutorialMode = window.location.hash === '#tutorial';
	@observable tutorialState = '';
	@observable tutorialPayout = 0;

	@observable oneTurnGame = true;
	introDiceShown = false;

	@observable errorMessage = '';

	@observable videoCloseButtonVisible = false;

	@observable phaserLoading = true;

	@observable _betAmounts = [
		1000000,
		100000,
		10000
	];

	set betAmounts(val){
		this._betAmounts = val;
	}

	@computed get betAmounts(){
		return this._betAmounts;
	}

	//Spinner
	@observable loadCount = 0;

	@computed get spinner(){
		if(this.phaserLoading && this.state === 'play'){
			return true;
		}
		return this.loadCount > 0;
	};

	@action setSpinner = (on) => {
		if(on){
			setTimeout(() => this.loadCount += 1, 500);
		} else {
			this.loadCount -= 1;
		}
	}

	@observable isImmediateRematch = false;


	@action setActiveMatch = (game, fromResume) => {
		this.activeMatch = new Match(game);
		this.activeMatch.fromResume = fromResume;
		this.state = 'play';

		if(localStorage.getItem('gameInProgress') === this.activeMatch.matchId.toString()){
			store.modal = 'resume';
		}
		if(!store.tutorialMode){
			window.setPersistentStorage('gameInProgress', store.activeMatch.matchId);
		}
	}

	@action rebet(){
		// integration.postAnalyticsEvent('rebet', 'postgame');
		return new Promise((resolve, reject) => {
			comm.GetBalance()
			.then(() => {
				if(store.user.balance >= store.user.lastBetAmount){
					comm.PlaceBet(store.user.lastBetAmount)
					.then(resolve)
					.catch(reject);
				} else {
					reject('user balance too low');
				}
			})
			.catch((err) => {
				reject('GetBalance failed.');
				store.state = 'bet';
			});
		});
	}

	@action updateMatch = () => {
		return comm.GetMatch(this.activeMatch.matchId)
		.then((data) => {
			// debugger;
			this.activeMatch.updateFromNetwork(data.Payload.Match);
		});
	}

	@computed get waitingForBet(){
		return this.user.id && !this.resuming && !this.activeMatch;
	}

	@action startMatchFromId(id, mode){
		if(!mode){
			mode = 'play';
		}
		return comm.GetMatch(id)
		.then((data) => {
			const matchData = data.Payload.Match;
			if(matchData && matchData.Type === 'ch' && matchData.UserState === 'pe'){
				return comm.AcceptChallenge(id)
				.then(() => {
					return comm.GetMatch(id)
					.then((data) => {
						this.betProcessing = false;
						// integration.onMatchStart();
						store.state = 'play';
						this.setActiveMatch(new Match(data.Payload.Match, mode, true));
						store.activeMatch.needToAcceptChallenge = true;
					});
				});
			} else {
				this.betProcessing = false;
				// integration.onMatchStart();
				store.state = 'play';
				this.setActiveMatch(new Match(data.Payload.Match, mode, true));
			}
		});
	}

	@action rollDice(held){
		let val = (store.activeMatch.handNumber * 10) + store.activeMatch.currentHand.rollNumber;
		integration.postAnalyticsEvent('dice_roll', store.tutorialMode ? 'tutorial' : 'gameplay', val);//, 'dice', held.length);

		return comm.ContinueRoll(store.activeMatch.matchId, held)
		.then(response => {
			if(response.ErrorCode === 300019){
				//let the game decide how to proceed since this is expected in the multiplayer game for now.
				return response;
			}
			if(response.ErrorCode === 300024 || response.ErrorCode === 300025){
				console.warn('Game action failed.')
				return response;
			}
			store.activeMatch.updateFromNetwork(response.Payload.Match);
			var roll = response.Payload.Match.UserMatchRounds.pop().Rolls.pop();
			var faces = roll.DiceRoll;
			var match = roll.BestHand ? roll.BestHand : [];
			if(faces.length !== 9 || faces.find(f => f > 5 || f < 0) !== undefined){
				throw new Error(`Out of bounds! Faces length: ${faces.length} or face beyond 0 - 6 ${faces}`);
			}
			faces.forEach((f, i)=>{
				this.activeMatch.currentHand.dice[i].showing = f;
			});
			this.activeMatch.currentHand.best = roll.BestPossibleHand;//response.best;
			this.activeMatch.currentHand.match = match;//response.match;
			this.activeMatch.currentHand.complete = roll.Completed;
			this.activeMatch.currentHand.bestHandTarget = roll.BestHandTarget;
			this.activeMatch.currentHand.lastCombination = roll.BestHandTarget;

			if(roll.Completed){
				this.updateMatch();
			}
			this.activeMatch.currentHand.nextRoll();
		});
	}
}

export const store = new MainStore();
